import React, { useState } from "react";
import styles from "./CaseStudy.module.css";
import { Container, Row, Col, Modal, Button } from "react-bootstrap";
import Buttons from "../buttons/Buttons";

const CaseStudy = ({
  tagLabel,
  pageTitle,
  bannerImage,
  clientStory,
  businessChallenge,
  midImage,
  solutions,
  solutionPoints,
  roiIntroLine1,
  roiIntroLine2,
  roiItems,
  takeawayText,
  cta,
  readingTitle,
  socialLinks,
  recommendations,
  solutionsOutro,
  solutionsSubheading,
  solutionsIntro,
  title = "Key Details",
  details = [],
}) => {
  const [showShareModal, setShowShareModal] = useState(false);
  const [copied, setCopied] = useState(false);
  const shareLink = window.location.href;

  const handleCopy = () => {
    try {
      const tempInput = document.createElement("textarea");
      tempInput.value = shareLink;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy text: ", err);
    }
  };
  return (
    <div className={`${styles.caseStudyContainer}`}>
      <Container className={styles.container}>
        {/* Section 1: Top Header Area */}
        <section className={styles.topSection}>
          <div className={styles.tag}>{tagLabel}</div>
          <h1 className={styles.pageTitle}>{pageTitle}</h1>
          <div className={styles.bannerWrapper}>
            <img
              src={bannerImage}
              alt={pageTitle}
              className={styles.bannerImage}
            />
          </div>
        </section>

        {/* Section 2: Two Column Content Area */}
        <Row className={styles.mainContentRow}>
          {/* Left Column - Scrollable Content (col-8) */}
          <Col lg={8} className={styles.leftColumn}>
            <div className={styles.scrollableContent}>
              {/* Client Story */}
              <section className={styles.contentSection}>
                <h2 className={styles.sectionTitle}>Our Client</h2>
                <div className={styles.sectionText}>{clientStory}</div>
              </section>
              <section className={`mb-3 ${styles.keyWrapper}`}>
                <div className={styles.keyContainer}>
                  <h3 className={styles.sectionTitle}>{title}</h3>

                  <div className={styles.list}>
                    {details.map((item, index) => (
                      <div key={index} className={styles.row}>
                        <span className={styles.label}>{item.label}:</span>
                        <span className={styles.value}>{item.value}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </section>
              {/* Business Challenge */}
              <section className={styles.contentSection}>
                <h2 className={styles.sectionTitle}>Business Challenge</h2>
                {businessChallenge.map((text, i) => (
                  <p key={i} className={styles.sectionText}>
                    {text}
                  </p>
                ))}
              </section>

              {/* Mid Image */}
              {midImage && (
                <div className={styles.midImageWrapper}>
                  <img
                    src={midImage}
                    alt="Business Challenge Visual"
                    className={styles.midImage}
                  />
                </div>
              )}

              {/* Our Solutions */}
              <section className={styles.contentSection}>
                <h2 className={styles.sectionTitle}>Our Solution</h2>

                {/* Intro Paragraph */}
                <p className={styles.sectionText}>{solutionsIntro}</p>

                {/* Subheading */}
                <h4 className={styles.sectionText}>{solutionsSubheading}</h4>

                {/* Bullet List */}
                <ul className={styles.bulletList}>
                  {solutionPoints.map((point, index) => (
                    <li key={index} className={styles.bulletItem}>
                      {point}
                    </li>
                  ))}
                </ul>

                {/* Closing line */}
                <p className={styles.sectionText}>{solutionsOutro}</p>
              </section>

              {/* ROI & Impact */}
              <section className={styles.contentSection}>
                <h2 className={styles.sectionTitle}>ROI & Impact</h2>

                {/* <p className={styles.roiIntro1}>
                  The solution delivered clear and measurable business value:
                </p> */}
                {roiIntroLine1 && (
                  <p className={styles.roiIntro1}>{roiIntroLine1}</p>
                )}

                <div className={styles.roiGrid}>
                  {roiItems.map((item, index) => (
                    <div key={index} className={styles.roiItem}>
                      {/* ICON */}
                      <div className={styles.roiIconContainer}>
                        <img
                          src={item.icon}
                          alt=""
                          className={styles.roiIcon}
                        />
                      </div>

                      {/* TEXT */}
                      <div className={styles.roiContent}>
                        {item.percent && (
                          <div className={styles.roiPercent}>
                            {item.percent}
                          </div>
                        )}

                        <h3 className={styles.roiTitle}>{item.title}</h3>

                        <p className={styles.roiDescription}>
                          {item.description}
                        </p>
                      </div>
                    </div>
                  ))}
                  {roiIntroLine2 && (
                    <p className={styles.roiIntro2}>{roiIntroLine2}</p>
                  )}
                </div>
              </section>

              {/* Key Takeaway */}
              <section className={styles.contentSection}>
                <div className={styles.takeawayBox}>
                  <h3 className={styles.takeawayTitle}>Key Takeaway</h3>

                  <div className={styles.takeawayTextWrapper}>
                    <span className={styles.quoteStart}>“</span>

                    <p className={styles.takeawayText}>{takeawayText}</p>

                    <span className={styles.quoteEnd}>”</span>
                  </div>
                </div>
              </section>
            </div>
          </Col>

          {/* Right Column - Sticky Sidebar (col-4) */}
          <Col lg={4} className={styles.rightColumn}>
            <div className={styles.stickySidebar}>
              {/* Reading Info */}
              <div className={styles.readingInfo}>
                <div className={`my-3 ${styles.readingRow}`}>
                  <span className={styles.readingLabel}>Reading:</span>
                  <span className={styles.readingText}>{readingTitle}</span>
                </div>

                {/* <div className={styles.readingTitleText}>{readingTitle}</div> */}
              </div>

              {/* Social Icons Row */}
              <div className={`mb-3 ${styles.socialRow}`}>
                {/* <a
                  href={socialLinks.linkedin}
                  target="_blank"
                  className={styles.socialIcon}
                  aria-label="LinkedIn"
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                  </svg>
                </a> */}
                {/* <a
                  href={socialLinks.twitter}
                  target="_blank"
                  className={styles.socialIcon}
                  aria-label="Twitter"
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.213c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
                  </svg>
                </a> */}
                {/* <a
                  href={socialLinks.facebook}
                  target="_blank"
                  className={styles.socialIcon}
                  aria-label="Facebook"
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                  </svg>
                </a> */}
                {/* <a
                  href={socialLinks.share}
                  className={styles.socialIcon}
                  target="_blank"
                  aria-label="Share"
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z" />
                  </svg>
                </a> */}
                <button
                  type="button"
                  className={styles.socialIcon}
                  aria-label="Share"
                  onClick={() => {
                    setShowShareModal(true);
                    // handleCopy();
                  }}
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z" />
                  </svg>
                </button>
              </div>

              {/* Recommendations Card */}
              <div className={styles.recommendationsCard}>
                <h3 className={styles.recommendationsTitle}>
                  Also You May Like
                </h3>
                <div className={styles.recommendationsList}>
                  {recommendations.map((rec, index) => (
                    <a
                      href={rec.link}
                      key={index}
                      className={styles.recommendationItem}
                    >
                      <div className={styles.recommendationImageWrapper}>
                        <img
                          src={rec.image}
                          alt={rec.title}
                          className={styles.recommendationImage}
                        />
                      </div>
                      <div className={styles.recommendationContent}>
                        <h4 className={styles.recommendationTitle}>
                          {rec.title}
                        </h4>
                      </div>
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </Col>
        </Row>
        {/* Full Width CTA Section */}
        <section className={styles.fullWidthCtaSection}>
          <div className={styles.ctaSection}>
            <h2 className={styles.ctaTitle}>{cta.title}</h2>
            <p className={styles.ctaDescription}>{cta.description}</p>
            <div className={styles.ctaButton}>
              <Buttons
                variant={cta.button?.variant || "secondary"}
                text={cta.button?.text}
                onClick={() => {
                  if (cta.button?.link) {
                    window.location.href = cta.button.link;
                  }
                }}
              />
            </div>
          </div>
        </section>
      </Container>
      {/* Share Modal */}
      <Modal
        show={showShareModal}
        onHide={() => setShowShareModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Share This Blog</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-column align-items-start w-100">
            <div className="position-relative w-100">
              <input
                type="text"
                className="form-control pe-5 rounded-md"
                value={shareLink}
                readOnly
                style={{ backgroundColor: "#f8f9fa", borderColor: "#dee2e6" }}
              />
              <i
                className="bi bi-clipboard position-absolute"
                title="Copy to clipboard"
                onClick={handleCopy}
                style={{
                  top: "50%",
                  right: "12px",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  color: "#6c757d",
                  fontSize: "1.2rem",
                }}
              ></i>
            </div>

            {copied && (
              <div
                className="text-success mt-2"
                style={{ fontSize: "14px", fontWeight: "500" }}
              >
                Link copied to clipboard!
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowShareModal(false)}
            className="rounded-md"
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CaseStudy;
